import { twMerge } from 'tailwind-merge';

type EmptyMessageProps = {
  text: string;
  className?: string;
};

export default function EmptyMessage({ text, className }: EmptyMessageProps) {
  return (
    <div
      className={twMerge(
        'flex h-full w-full flex-1 items-center justify-center',
        className,
      )}
    >
      <span className="text-sm text-base-content/60">{text}</span>
    </div>
  );
}
